
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppButton } from '@/components';
import useIapEdit from '@/modules/iap/model/edit';
import { ROUTE_NAME_IAP } from '@/modules/iap/router';

export default defineComponent({
    name: ROUTE_NAME_IAP.EDIT,
    components: { AppFormRow, AppInput, AppSelect, AppButton, AppCard },
    setup() {
        const { v$, model, features, fetch, update } = useIapEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, features, update };
    }
});
